<div class="row c-media-from-computer">
    <div class="p15">
      <div @dragover="dragover" @dragleave="dragleave" @drop="drop" class="drop-media-controller">
        <img :src="require('@/assets/icons/upload.png')" class="w62" />
        <div class="row txt-center"><b>{{ $t("componentDragAndDropFile") }}</b></div>
        <div class="row txt-center">{{ $t("componentUploadFromComputer") }}
          <label for="uploadMedia" class="txt-detail"><b>{{ $t("componentHere") }}</b></label>
          <input @change="onChange" id="uploadMedia" :multiple="isArray" type="file" ref="fileInput" accept=".svg,.jpg,.jpeg,.png,.gif,.webp" class="input-file-media" />
        </div>
      </div>
    
      <div v-if="files[0]" class="row mt15">
        <div class="mv12" style="border: 1px solid var(--gray-dark);border-radius: var(--radius);padding: 15px;">
          <legend><b>{{ $t("componentSelectedFile") }}</b></legend>
          <div class="row mt8">
            <div class="row mb18">
              <div class="go-right">
                <b class="font13 mr6">{{ $t("componentBtnUploadTo") }}</b>
                <select v-model="folder" class="input select-folder">
                  <option v-for="folder in $store?.state?.medias" :value="folder.code">{{folder.title}}</option>
                </select>
                <!-- <c-select v-model:value="folder" :options="$store?.state?.medias" optionValue="code" optionLabel="title" class="input select-folder"></c-select> -->
              </div>
            </div>
            <div class="row">
              <div v-for="(file, fileIndex) in files" :key="file.name" class="list-selected-media">
                <input v-model="beforeUploadIndex" :value="fileIndex" type="radio" :checked="beforeUploadIndex === fileIndex" class="btn-radio-before-check" />
    
                <div class="box-item-media" style="left: 45px;">
                  <c-img :src="fileToPath(file)" :isPath="false"  class="img img-cover"/>
                </div>
                <div class="row image-thumbnail-desc">
                  <p class="mv6 thumbnail-image-name">{{ file.name }}</p>
                  <div class="box-progress-bar">
                    <div v-if="uploadIndexIndex === fileIndex && isUploading" :style="{width: uploadPercentage + '%'}" :class="{'active-uploading' : isUploading}" class="progress-bar"></div>
                    <div v-else :style="{width: '0%'}" class="progress-bar"></div>
                  </div>
                </div>
                <div @click="removeDraftFile(fileIndex), beforeUploadIndex = -1" class="btn-remove-media">
                  <i class="fa fa-times"></i>
                </div>
  
                <div class="btn-upload-right txt-right p15 pt0">
                  <!-- <button @click="$emit('onUndo')" class="btn btn-secondary btn-sm">Cancel</button> -->
                  <button v-if="beforeUploadIndex !== fileIndex" class="btn btn-danger btn-disabled btn-sm ml6">{{ $t("componentBtnUpload") }}</button>
                  <button v-if="isUploading && beforeUploadIndex === fileIndex" class="btn btn-danger btn-disabled btn-sm ml6">{{ $t("componentBtnUploading") }}...</button>
                  <button v-if="!isUploading && beforeUploadIndex === fileIndex" @click="submitUpload" class="btn btn-danger btn-sm ml6">{{ $t("componentBtnUpload") }}</button>
                </div> 
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="mt15">
        <div class="row mv12" style="border: 1px solid var(--gray-dark);border-radius: var(--radius);padding: 15px;">
          <legend style="top: -11px;"><b>{{ $t("componentUploadedFile") }}</b></legend>
          <div class="row" style="width: 100%;">
            <div class="row">
              <div v-for="(file, fileIndex) in serverMedia" :key="fileIndex" class="list-selected-media" style="width: 100%;">
                <input v-if="isArray" v-model="form.code" :value="file.key" @change="onChangeMedia" type="checkbox" class="btn-radio-before-check" />
                <input v-else v-model="form.code" :value="file.key" @change="onChangeMedia" type="radio" class="btn-radio-before-check" />
    
                <div class="box-item-media" style="left: 45px;">
                  <c-img :src="$helper?.getFullImage(file?.key)"  class="img img-cover"/>
                </div>
                <div class="row image-thumbnail-desc" style="width: 100%;">
                  <p class="mv6 mt15 thumbnail-image-name">{{ file.key || "N/A" }}</p>
                </div>
              </div>
            </div>
          </div>

          <div v-if="!serverMedia[0]" class="row mt15">
            <c-empty></c-empty>
          </div>
        </div>
      </div>
    </div> 
  </div>